module.exports = __webpack_public_path__ + "img/overseas-business-wechat-official-accounts_4.a7a15969.png";